import { apiHost, apiAppKey, apiAppSecret, apiStage } from './config';
import request from 'request';
const Tools = require('../tools.js');
const CryptoJS = require('crypto-js');

class ApiClient {
  constructor() {
    this.appKey = apiAppKey;
    this.appSecret = apiAppSecret; //Buffer.from(secret, 'utf8');
    this.stage = apiStage;
  }

  request(method, endpoint, data, otherOptions = {}) {

    let params = {};

    for (let key in data) {
      // eslint-disable-next-line no-undefined
      if (data[key] !== undefined && data[key] !== null) {
        params[key] = typeof data[key] === 'string' ? data[key].trim() : data[key];
      }
    }

    var headers = this.buildHeaders();

    if (otherOptions.headers) {
      headers = {
        ...headers,
        ...otherOptions.headers
      };
    }
    var signHeaderKeys = this.getSignHeaderKeys(headers);

    headers['x-ca-signature-headers'] = signHeaderKeys.join(',');
    var signedHeadersStr = this.getSignedHeadersString(signHeaderKeys, headers);
    var stringToSign = this.buildStringToSign(method, headers, signedHeadersStr, endpoint, params);

    headers['x-ca-signature'] = this.sign(stringToSign);

    return new Promise((resolve, reject) => {
      let options = {
        url: apiHost + endpoint,
        method: method,
        json: true,
        headers: headers
      };

      if (method === 'GET') {
        options.url = this.fomatQueryUrl(endpoint, params);
      } else if (method === 'POST') {
        options.form = params;
      }

      if (otherOptions.body) {
        options.url = this.fomatQueryUrl(endpoint, params);
        options.form = null;
        options.body = otherOptions.body;
        options.json = false;
      }

      request(options, function(error, response, body) {
        if (error) {
          if (/Failed\sto\sfetch/.test(error)) {
            error = {
              message: '网络已断开，请检查网络'
            };
            console.log(error);
          }
          return reject(error);
        }

        if (!error && response.statusCode === 200) {
          return resolve(body);
        }
        return reject(response.body);
      });
    });
  }

  fomatQueryUrl(endpoint, params) {
    let query = null;

    for (let key in params) {
      let value = encodeURIComponent(`${params[key]}`);

      if (!query) {
        query = `${key}=${value}`;
      } else {
        query += `&${key}=${value}`;
      }
    }

    let url = apiHost + endpoint;

    if (query) {
      url = apiHost + endpoint + '?' + query;
    }
    return url;
  }

  buildHeaders() {
    return {
      'x-ca-timestamp': Date.now(),
      // // "content-md5": "",
      'x-ca-key': this.appKey,
      'x-ca-nonce': Tools.generateUUID(),
      'x-ca-stage': this.stage,
      accept: 'application/json, text/plain, */*, application/json',
      'content-type': 'application/x-www-form-urlencoded'
    };
  }

  getSignHeaderKeys(headers) {
    var keys = Object.keys(headers).sort();
    var signKeys = [];

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // x-ca- 开头的header

      if (key.startsWith('x-ca-')) {
        signKeys.push(key);
      }
    }

    // 按字典序排序
    return signKeys.sort();
  }

  getSignedHeadersString(signHeaders, headers) {
    var list = [];

    for (var i = 0; i < signHeaders.length; i++) {
      var key = signHeaders[i];

      list.push(key + ':' + headers[key]);
    }

    return list.join('\n');
  }

  getParsedUrl(endpoint, data) {
    var pairs = [];
    var keys = Object.keys(data).sort();

    keys.forEach(k => {
      if (data[k] === '') {
        pairs.push(k);
      } else {
        pairs.push(k + '=' + data[k]);
      }
    });

    if (pairs.length === 0) {
      return endpoint;
    }

    return endpoint + '?' + pairs.join('&');
  }

  buildStringToSign(method, headers, signedHeadersStr, endpoint, data) {
    // accept, contentMD5, contentType,
    const lf = '\n';
    var list = [method, lf];

    var accept = headers['accept'];

    if (accept) {
      list.push(accept);
    }
    list.push(lf);

    var contentMD5 = headers['content-md5'];

    if (contentMD5) {
      list.push(contentMD5);
    }
    list.push(lf);

    var contentType = headers['content-type'];

    if (contentType) {
      list.push(contentType);
    }
    list.push(lf);

    var date = headers['date'];

    if (date) {
      list.push(date);
    }
    list.push(lf);

    if (signedHeadersStr) {
      list.push(signedHeadersStr);
      list.push(lf);
    }

    list.push(this.getParsedUrl(endpoint, data));
    return list.join('');
  }

  sign(stringToSign) {
    return CryptoJS.enc.Base64.stringify(
      CryptoJS.HmacSHA256(stringToSign, this.appSecret)
      // CryptoJS.MD5(stringToSign, this.appSecret)
    );
  }
}

const apiClient = new ApiClient();

export default apiClient;
